(function () {
  function fillSlidesForLoop(slider, minCount) {
    if (slider.dataset.loopFilled === 'true') return;
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const originals = Array.from(wrapper.children);
    if (!originals.length) return;
    while (wrapper.children.length < minCount) {
      originals.forEach(function (slide) {
        if (wrapper.children.length >= minCount) return;
        wrapper.appendChild(slide.cloneNode(true));
      });
    }
    slider.dataset.loopFilled = 'true';
  }

  function initStoreCollection(section) {
    const slider = section.querySelector('[class*="store-collection-slider-"]');
    if (!slider) return;
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
    fillSlidesForLoop(slider, 8);
    new Swiper(slider, {
      loop: true,
      rewind: true,
      spaceBetween: 10,
      slidesPerView: 2.8,
      watchSlidesProgress: true,
      grabCursor: true,
      allowTouchMove: true,
      breakpoints: {
        768: {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  }

  function initAll() {
    document
      .querySelectorAll('.store-collection-column-section')
      .forEach(function (section) {
        initStoreCollection(section);
      });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initStoreCollection(event.target);
  });
  document.addEventListener('shopify:section:reorder', initAll);
})();
